import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const UndoIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 9H15C17.761 9 20 11.239 20 14C20 16.761 17.761 19 15 19H12M4 9L8 5M4 9L8 13"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

UndoIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(UndoIcon);
